import { Bike, PersonStanding, Store, UtensilsCrossed } from "lucide-react";

export const TYPE = { delivery: [Bike, "Entrega"], retirada: [PersonStanding, "Retirada"], mesa: [UtensilsCrossed, "Mesa"], local: [Store, "No local"], comanda: [UtensilsCrossed, "Comanda"] };
export const GROUPS = ["recebido", "confirmado", "preparo", "pronto", "entrega", "entregue", "cancelado"];
const LABEL = { recebido: "Recebido", confirmado: "Confirmado", preparo: "Em preparação", pronto: "Pronto", entrega: "Saiu para entrega", entregue: "Entregue", concluido: "Entregue", cancelado: "Cancelado" };
export const groupLabel = (s) => LABEL[s];

export const TONE = {
  recebido: ["border-l-red-500", "bg-red-500/15 text-red-600 dark:text-red-400"],
  confirmado: ["border-l-blue-500", "bg-blue-500/15 text-blue-600 dark:text-blue-400"],
  preparo: ["border-l-orange-400", "bg-orange-400/20 text-orange-700 dark:text-orange-300"],
  pronto: ["border-l-lime-500", "bg-lime-400/25 text-lime-800 dark:text-lime-300"],
  entrega: ["border-l-violet-500", "bg-violet-500/15 text-violet-700 dark:text-violet-300"],
  entregue: ["border-l-slate-400", "bg-slate-500/15 text-slate-600 dark:text-slate-300"],
  cancelado: ["border-l-slate-300", "bg-slate-500/10 text-slate-500 line-through"],
};

export const groupOf = (o) => (o.status === "concluido" ? "entregue" : o.status);
export const toneOf = (o) => TONE[groupOf(o)] || TONE.entregue;
export const isDone = (o) => ["entregue", "concluido", "cancelado"].includes(o.status);
export const statusLabel = (o) => (o.status !== "pronto" ? LABEL[o.status] || o.status
  : o.type === "delivery" ? "Pronto para entrega" : o.type === "retirada" ? "Esperando retirada" : "Pronto");

const mins = (iso) => Math.max(0, Math.floor((Date.now() - new Date(iso).getTime()) / 60000));
const hm = (m) => (m < 60 ? `${m} min` : `${Math.floor(m / 60)}h${String(m % 60).padStart(2, "0")}`);
export const elapsed = (iso) => hm(mins(iso));
export const agoText = (iso) => (mins(iso) < 1 ? "há poucos segundos" : `há ${hm(mins(iso))}`);
export const lastChange = (o) => (o.history?.length ? o.history[o.history.length - 1].at : o.created_at);
